var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.localizations)?_c('update-localization-form',{attrs:{"localizable-id":_vm.bannerId,"localizations":_vm.localizations,"localizable-type":"banner"},on:{"submit":_vm.saveLocalizations}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }